import { createFeatureSelector, createSelector } from "@ngrx/store";
import {
  TestCaseGeneratorState,
  jiraAdapter,
  testCaseAdapter,
  testCaseByVersionIdAdapter,
  testCaseVersionAdapter,
} from "../states/testcase-generator.state";

// Feature Selector
export const selectTestCaseGeneratorState =
  createFeatureSelector<TestCaseGeneratorState>("testcaseGenerator");

// Select JIRA Stories State
export const selectJiraStoriesState = createSelector(
  selectTestCaseGeneratorState,
  (state) => state.jiraStories
);

// Select Test Cases State
export const selectTestCasesState = createSelector(
  selectTestCaseGeneratorState,
  (state) => state.testCases
);

// Select Test Cases Versions State
export const selectTestCaseVersionsState = createSelector(
  selectTestCaseGeneratorState,
  (state) => state.testCaseVersions
);

// Select Test Cases By Version ID
export const selectTestCasesByVersionIdState = createSelector(
  selectTestCaseGeneratorState,
  (state) => state.testCasesByVersionId
);

// Select Loading
export const selectLoading = createSelector(
  selectTestCaseGeneratorState,
  (state) => state.loading
);

// Select Generating
export const selectGenerating = createSelector(
  selectTestCaseGeneratorState,
  (state) => state.generating
);

// Select Loading Testcases
export const selectLoadingTestCases = createSelector(
  selectTestCaseGeneratorState,
  (state) => state.loadingTestCases
);

export const selectProgressMessages = createSelector(
  selectTestCaseGeneratorState,
  (state) => state.message
);

// Select Error
export const selectError = createSelector(
  selectTestCaseGeneratorState,
  (state) => state.error
);

// JIRA Stories Selectors
export const {
  selectAll: selectAllJiraStories,
  selectEntities: selectJiraStoryEntities,
} = jiraAdapter.getSelectors(selectJiraStoriesState);

// Test Cases Selectors
export const {
  selectAll: selectAllTestCases,
  selectEntities: selectTestCaseEntities,
} = testCaseAdapter.getSelectors(selectTestCasesState);

// Test Case Version Selector
export const {
  selectAll: selectAllTestCaseVersions,
  selectEntities: selectTestCaseVserionsEntities,
} = testCaseVersionAdapter.getSelectors(selectTestCaseVersionsState);

// Test Cases By version Id Selectors
export const {
  selectAll: selectAllTestCasesByVersionId,
  selectEntities: selectTestCaseByVserionIdEntities,
} = testCaseByVersionIdAdapter.getSelectors(selectTestCasesByVersionIdState);

/** Unique user story keys from test cases loaded for the current version. */
export const selectStoryIdsByVersionId = createSelector(
  selectAllTestCasesByVersionId,
  (cases) =>
    [...new Set(
      (cases ?? [])
        .map((tc: any) => tc.key)
        .filter((key): key is string => !!key)
    )],
);

// Select Test Cases State
export const selectVersionIdState = createSelector(
  selectTestCaseGeneratorState,
  (state) => state.versionId
);